(function () {
  function init() {
    const header = document.querySelector('.xo-header--style-3');
    if (!header) return;

    const section = header.closest('.section-header');
    const body = header.querySelector('.xo-header__body');
    if (!body) return;

    let lastY = window.scrollY;
    let stickyOffset = 0;   // scrollY at which sticky activates
    let reservedHeight = 0; // height reserved in page flow when fixed
    let ticking = false;

    function measure() {
      // Reserve the header's own natural height when it goes fixed,
      // so the page below doesn't collapse upward by that amount.
      reservedHeight = section ? section.offsetHeight : body.offsetHeight;
      // Activate sticky exactly when the header reaches the top of the viewport.
      // When an announcement bar (or any section) sits above the header, its
      // height equals section.offsetTop — so sticky takes over right as that
      // scrolls past, with no visible position jump. When the header is the
      // first thing on the page (offsetTop = 0) we fall back to the old
      // "scroll past the header" trigger so the header doesn't snap fixed on
      // the very first pixel of scroll.
      const topOffset = section ? section.offsetTop : 0;
      stickyOffset = topOffset > 0 ? topOffset : reservedHeight;
    }

    function tick() {
      const y = window.scrollY;

      if (y <= stickyOffset) {
        header.classList.remove('xo-header--js-sticky', 'xo-header--js-hidden');
        if (section) section.style.minHeight = '';
      } else {
        if (!header.classList.contains('xo-header--js-sticky')) {
          if (section) section.style.minHeight = reservedHeight + 'px';
          header.classList.add('xo-header--js-sticky');
        }
        if (y > lastY) {
          header.classList.add('xo-header--js-hidden');
        } else {
          header.classList.remove('xo-header--js-hidden');
        }
      }

      lastY = y;
      ticking = false;
    }

    measure();
    window.addEventListener('load', measure, { passive: true });
    window.addEventListener('resize', measure, { passive: true });

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(tick);
        ticking = true;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
